import React from 'react';
import { BetPickBtn } from './PickButtons.styled';
import useTrioState from 'features/TrackPage/hooks/useTrioState';
import useRowSelection from 'features/TrackPage/hooks/useRowSelection';

const TrioPickColumnButtons = () => {
    const { trioMarksIndicator } = useTrioState();
    const { toggleTrioRow } = useRowSelection();

    return (
        <div className="flex col-gap-5 pl-15 fade-in">
            <BetPickBtn active={trioMarksIndicator[1]} onClick={() => toggleTrioRow(1)}>
                1
            </BetPickBtn>
            <BetPickBtn active={trioMarksIndicator[2]} onClick={() => toggleTrioRow(2)}>
                2
            </BetPickBtn>
            <BetPickBtn active={trioMarksIndicator[3]} onClick={() => toggleTrioRow(3)}>
                3
            </BetPickBtn>
        </div>
    );
};

export default TrioPickColumnButtons;
